import $ from 'jquery';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/tooltip';


$('a.footnote, a.footnote-anchor').tooltip({
    placement: 'top',
    trigger: 'hover',
    title: function() {
        return document.querySelector(this.hash).textContent
    },
    animation: true,
});

let anchors = document.querySelectorAll('.main-content a');
anchors.forEach(anchor => {
    const pattern = /^([a-z0-9|-]+)/g
    const subdomain = window.location.host.match(pattern)

    if (!anchor.href.includes(subdomain[0])) {
        anchor.target = '_blank'
    }

})